// Mock data for Salumificio Lombardi 1957

export const businessInfo = {
  name: "Salumificio Lombardi 1957",
  tagline: "Sicuri di fare la spesa giusta a Santarcangelo di Romagna",
  foundedYear: 1957,
  location: {
    address: "Via Trasversale Marecchia, 1411",
    city: "Santarcangelo di Romagna",
    postalCode: "47822",
    province: "RN",
    fullAddress: "Via Trasversale Marecchia, 1411, 47822 Santarcangelo di Romagna RN",
    coordinates: {
      lat: 44.0658,
      lng: 12.4469
    }
  },
  contact: {
    phone: "0541 750295",
    whatsapp: "3500098273",
    instagram: "https://www.instagram.com/lombardisalumi",
    facebook: "https://www.facebook.com/lombardi1957/?locale=it_IT"
  },
  hours: {
    weekdays: "08:30–12:30, 15:30–19:00",
    weekend: "Chiuso"
  }
};

// Real photos from the shop
export const photos = {
  hero: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/uqrhkequ_i00899.jpg",
  curedMeats: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/uqrhkequ_i00899.jpg",
  freshMeats: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/k8d0qnro_BANCO-SPIEDINI210922CHIARAGIALLA.JPG",
  preparations: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/n9q90if2_svizzere.JPG",
  bbqAerial: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/y6vwr6cz_1.jpg",
  bbqGrill: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/8ng9uleb_3.jpg",
  historyOld: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/ixs8kb3s_IMG_20220202_134935.jpg",
  historyVintage: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/4vdtj0mn_banco%2083.jpg"
};

export const products = {
  curedMeats: {
    title: "Salumi Stagionati",
    description: "I nostri salumi sono preparati seguendo le ricette tradizionali romagnole con carne di suini di provenienza esclusivamente dall'Emilia Romagna.",
    items: [
    {
      name: "Prosciutti",
      description: "Prosciutti stagionati con cura secondo la tradizione romagnola, dal sapore autentico e intenso."
    },
    {
      name: "Coppe",
      description: "Coppe di alta qualità, stagionate lentamente per ottenere un gusto ricco e profumato."
    },
    {
      name: "Pancette",
      description: "Pancette artigianali, perfette per arricchire ogni piatto con il sapore della tradizione."
    },
    {
      name: "Salami",
      description: "Salami preparati con ricette di famiglia, tramandati di generazione in generazione."
    },
    {
      name: "Salsicce",
      description: "Salsicce fresche e genuine, preparate quotidianamente con carne selezionata."
    }],

    image: photos.curedMeats
  },
  freshMeats: {
    title: "Carne Fresca Selezionata",
    description: "Selezioniamo con cura le migliori carni per garantire qualità e freschezza ad ogni acquisto.",
    items: [
    {
      name: "Suino",
      description: "Carne di maiale fresca di prima qualità, proveniente da allevamenti locali dell'Emilia Romagna."
    },
    {
      name: "Bovino",
      description: "Tagli pregiati di carne bovina, selezionati per offrire morbidezza e sapore."
    },
    {
      name: "Ovino",
      description: "Carne di agnello e pecora, ideale per le ricette tradizionali della nostra terra."
    },
    {
      name: "Pollame",
      description: "Pollo, tacchino e altri volatili, sempre freschi e di alta qualità."
    }],

    image: photos.freshMeats
  },
  preparations: {
    title: "Preparati Pronti",
    description: "Preparazioni pronte da cuocere, ideali per chi vuole portare in tavola qualità e tradizione con praticità.",
    items: [
    {
      name: "Svizzere",
      description: "Varie tipologie di svizzere, preparate con cura e pronte per essere cucinate."
    },
    {
      name: "Spiedini",
      description: "Spiedini assortiti di carne, perfetti per grigliate e occasioni speciali."
    },
    {
      name: "Arrosticini",
      description: "Arrosticini tradizionali, pronti per essere gustati alla brace."
    },
    {
      name: "Costicce Condite",
      description: "Costicce di maiale condite con le nostre spezie artigianali, pronte per la cottura."
    }],

    image: photos.preparations
  }
};

export const bbqArea = {
  title: "Area Barbecue Estiva",
  description: "Durante i mesi estivi, il nostro salumificio offre un'accogliente area barbecue all'aperto, dove potete gustare le nostre carni in un'atmosfera conviviale e familiare.",
  features: [
  "Spazio all'aperto attrezzato",
  "Atmosfera familiare e sociale",
  "Carni fresche grigliate al momento",
  "Perfetto per pranzi e cene in compagnia"],

  images: [photos.bbqAerial, photos.bbqGrill]
};

export const ourStory = {
  title: "La Nostra Storia",
  subtitle: "Dal 1957, tradizione e qualità di generazione in generazione",
  story: `Dagli inizi della sua storia, cominciata negli <strong>anni '50 del secolo scorso</strong>, il salumificio Lombardi ha sede a Santarcangelo di Romagna, a soli 10 km da Rimini.

Tutto ebbe inizio con la felice <strong>intuizione del nonno Giovanni</strong> che, abbandonata la vita di contadino, decise di dedicarsi alla lavorazione delle carni. Da allora, di generazione in generazione, conserva gli accorgimenti della <strong>tradizione nella preparazione</strong> di salumi e insaccati. Per anni la famiglia Lombardi è stata un riferimento per tutti coloro che volevano lavorare o acquistare carne di maiale, a livello locale.

Successivamente, sotto la <strong>guida del signor Tonino Lombardi</strong>, l'azienda conobbe un florido sviluppo e diventò il riferimento anche <strong>fuori dal comune di Santarcangelo</strong>, fino ad essere conosciuta in tutta l'Emilia Romagna.

Oggi, guidato da una nuova generazione di Lombardi, il salumificio continua a proporre con successo i suoi salumi e insaccati, seguendo <strong>ricette romagnole tradizionali</strong>, utilizzando materie prime di qualità e carne di suini esclusivamente di provenienza dall'Emilia Romagna.`,
  values: [
  {
    title: "Tradizione",
    description: "Ricette tramandate dal 1957"
  },
  {
    title: "Qualità",
    description: "Solo materie prime selezionate"
  },
  {
    title: "Artigianalità",
    description: "Lavorazione manuale e cura dei dettagli"
  },
  {
    title: "Famiglia",
    description: "Tre generazioni al vostro servizio"
  }],

  images: [photos.historyOld, photos.historyVintage]
};

export const gallery = [
{
  url: photos.curedMeats,
  alt: "Salumi stagionati artigianali",
  category: "products"
},
{
  url: photos.freshMeats,
  alt: "Banco con spiedini e preparati",
  category: "products"
},
{
  url: photos.preparations,
  alt: "Svizzere preparate",
  category: "products"
},
{
  url: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/j8zplvfa_IMG_1626.JPG",
  alt: "Salsicce fresche artigianali",
  category: "products"
},
{
  url: "https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/u8fx59hj_prosciutto65euro.JPG",
  alt: "Prosciutto stagionato",
  category: "products"
},
{
  url: photos.bbqGrill,
  alt: "Barbecue con salsicce",
  category: "bbq"
},
{
  url: photos.bbqAerial,
  alt: "Area barbecue estiva",
  category: "bbq"
},
{
  url: photos.historyVintage,
  alt: "Il negozio negli anni passati",
  category: "history"
},
{
  url: photos.historyOld,
  alt: "Storia del Salumificio Lombardi",
  category: "history"
},
{
  url: "https://customer-assets-lxgj4vgw.emergentagent.net/job_lombardi-salumi/artifacts/v44yozih_IMG_0041%20copia.webp",
  alt: "Il salumificio oggi - interno moderno",
  category: "shop"
}];